import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Tabs from "../../Tabs";

const UserStatsSkeleton = () => {
	const { t } = useTranslation();

	const currentMonthTabs = useMemo(() => {
		return [
			{
				label: t("current_month"),
				content: (
					<Box sx={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
						<Skeleton
							variant="rectangular"
							sx={{
								flex: { xs: "0 1 20%", xl: "0 1 20%" },
								minWidth: "236px",
								maxWidth: "380px",
							}}
							height={132}
						/>
						<Skeleton
							variant="rectangular"
							sx={{
								flex: { xs: "0 1 20%", xl: "0 1 20%" },
								minWidth: "236px",
								maxWidth: "380px",
							}}
							height={132}
						/>
						<Skeleton
							variant="rectangular"
							sx={{
								flex: { xs: "0 1 20%", xl: "0 1 20%" },
								minWidth: "236px",
								maxWidth: "380px",
							}}
							height={132}
						/>
						<Skeleton
							variant="rectangular"
							sx={{
								flex: { xs: "0 1 20%", xl: "0 1 20%" },
								minWidth: "236px",
								maxWidth: "380px",
							}}
							height={132}
						/>
					</Box>
				),
			},
		];
	}, []);

	const prevMonthTabs = useMemo(() => {
		return [
			{
				label: t("previous_months"),
				content: <Skeleton variant="rectangular" height={242.83} />,
			},
		];
	}, []);

	const carrierTabs = [
		{
			label: t("carriers"),
			content: <Skeleton variant="rectangular" width={123.4} height={35.8} />,
		},
	];

	return (
		<>
			<Tabs ariaLabel={t("current_month")} tabs={currentMonthTabs} />
			<Tabs ariaLabel={t("previous_months")} tabs={prevMonthTabs} />
			<Tabs ariaLabel={t("carriers")} tabs={carrierTabs} />
		</>
	);
};

export default UserStatsSkeleton;
